// Production: Secure mode
export const SecurityStatus = "0"; // 🔐 Encryption Status  0 - Enabled | 1 - Disabled 
// Development/Testing: Plain mode  
export const SECRET_KEY_Storage="Init@SecureLocalStorage"

export const DirectDeduct = process.env.REACT_APP_DEDUCTION_DIRECT_HALFDAY;
